<div class="button-skip">
  <svg
    id="uuid-edcd4280-a4c4-4a53-87f7-52353df10668"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.27 85.63">
    <g id="uuid-bd3eca5f-ec42-4ce3-8220-36851398273e" data-name="button-skip">
      <g data-name="button_play" data-name="button_skip_down"
        id="uuid-a340166d-0994-44d7-96b7-6eb5791cc300"><path
          d="M58.21,83.01c-1.22,1.42-9.97,2.44-21.51,2.45-11.54,0-21.68-.81-21.5-2.58.14-1.43,7.63-2.63,21.5-2.58,11.53.04,22.98,1.01,21.51,2.72"
          style="opacity:.15; stroke-width:0px;" /><path
          d="M5.29,34.27C3.85,18.03,16.39,5.57,34.39,5.14c16.3-.39,28.12,14.32,30.41,30.46,2.34,16.51-9.13,25.64-25.21,28.34-25.58,4.3-32.86-13.44-34.3-29.68"
          style="fill:#bf8d00; stroke-width:0px;" /><path
          d="M24.24,46.88c-.19,0-.37-.05-.54-.15-.33-.19-.54-.54-.54-.93l-.17-20c0-.39.2-.75.54-.94.34-.19.75-.19,1.09,0l17.49,10.25c.33.2.54.55.53.94,0,.39-.21.74-.55.93l-17.32,9.75c-.16.09-.35.14-.53.14Z"
          style="fill:#fff; stroke-width:0px;" /><line x1="47.28" y1="24.72"
          x2="47.28" y2="46.88"
          style="fill:none; stroke:#fff; stroke-linecap:round; stroke-miterlimit:10; stroke-width:3.41px;" />
      </g>
      <g id="uuid-e6c327aa-adda-4f46-97d5-fc2e1ca168f1" data-name="button_skip_up"><path
          d="M.13,34.17C-1.55,15.12,13.15.51,34.26,0c19.11-.46,32.98,16.8,35.66,35.72,2.74,19.36-10.71,30.07-29.56,33.24C10.36,74.02,1.82,53.21.13,34.17"
          style="fill:#ffbc00; stroke-width:0px;" /><path
          d="M59.56,83.02c-1.3,1.51-10.6,2.6-22.87,2.6-12.27,0-23.05-.86-22.86-2.75.15-1.52,8.12-2.8,22.86-2.75,12.26.04,24.43,1.07,22.87,2.89"
          style="opacity:.15; stroke-width:0px;" /><path
          d="M22.36,48.96c-.22,0-.44-.06-.63-.17-.39-.22-.63-.64-.63-1.09l-.2-23.46c0-.46.24-.88.63-1.11.39-.23.88-.23,1.28,0l20.51,12.02c.39.23.63.65.63,1.1,0,.45-.25.87-.65,1.09l-20.31,11.44c-.19.11-.41.16-.62.16Z"
          style="fill:#fff; stroke-width:0px;" /><line x1="49.38" y1="22.97"
          x2="49.38" y2="48.96"
          style="fill:none; stroke:#fff; stroke-linecap:round; stroke-miterlimit:10; stroke-width:4px;" />
      </g>
    </g>
  </svg>
</div>
